import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";

/**
 * Creates a Valuation Event based on a Project
 */
export class CreateValuationEventFromProjectGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase) {
    super(injector, workspace, 'newPortfolioClickFromProjectStd');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    this.eventBus.broadcastEvent('createValuationPortfoliosData', this.workspace.grid.selectedItem);
  }
}
